import { TeaBlocksError } from './../../../TeaBlocksError';
import { ReturnBlock } from "../../ReturnBlock";

/**
 * Math multiplication block. Multiplies values together.
 */
export class ProductBlock extends ReturnBlock {
    operands;
    
    /**
     * Constructor
     * @param  operands operands of multiplication
     */
    constructor(id: string, operands: ReturnBlock[]){
        super(id)
        this.operands = operands;
    }

    /**
     * Evaluates the expression
     * @param varEnv variable environment
     * @returns all operands multiplied together (1 if there are no operands)
     */
    evalBlock(varEnv: Map<string, any>): number{
        let ans = 1;

        for(let op of this.operands){
            let val = Number(op.evalBlock(varEnv));
            if(isNaN(val)) throw new TeaBlocksError("Input not a number", this.id);
            if (val === 0) return 0;

            ans *= val;
        }

        return ans;
    }    
}
